<template>
    <section>
        <div class="page">
            <div>
                <h2>
                    Deleting chats
                </h2>
                <p>
                    Deleting a chat allows you to delete a chat from your Chats tab.
                </p>
                <h3>
                    To delete an individual chat or group chat
                </h3>
                <ol>
                    <li>
                        In the Chats tab, tap and hold the chat you wish to delete.
                    </li>
                    <li>
                        Tap <strong>Delete</strong>.
                    </li>
                </ol>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
